import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import { Box, Icon } from "@chakra-ui/react";
import {
  getSocialProviderBySocialType,
  getSocialProviderStyles,
} from "../../../_utils/socialProvider";

const wrapperStyles = {
  width: "1em",
  height: "1em",
  padding: "0.2em",
  lineHeight: 0,
  borderRadius: "full",
  color: "white",
};

const iconStyles = {
  fontSize: "0.6em", // 1 - (2 * 0.2)
};

const getByType = (type) => {
  const provider = getSocialProviderBySocialType(type);
  const styles = getSocialProviderStyles(provider);

  return styles || {};
};

const SocialTypeIcon = ({ socialType, ...props }) => {
  const data = useMemo(() => getByType(socialType), [socialType]);

  return (
    <Box sx={wrapperStyles} backgroundColor={data?.background} {...props}>
      <Icon as={data?.icon} sx={iconStyles} />
    </Box>
  );
};

SocialTypeIcon.propTypes = {
  socialType: PropTypes.string.isRequired,
};

export default memo(SocialTypeIcon);
